import { render } from "./LoginAuth.vue?vue&type=template&id=707c972d&scoped=true&ts=true"
import script from "./LoginAuth.vue?vue&type=script&lang=ts"
export * from "./LoginAuth.vue?vue&type=script&lang=ts"

import "./LoginAuth.vue?vue&type=style&index=0&id=707c972d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707c972d"]])

export default __exports__